import { useDialog } from "@/hooks/useDialog";
import { Box } from "@chakra-ui/react";

import {
  colors,
  customEvent,
  getCdnImageSrc,
  GoiLogo,
  GOI_AUDIT_REPORT_URL,
  GOI_COMPANY_ADDRESS,
  HLine,
  HStack,
  Image,
  NextLink,
  Spacing,
  VStack,
} from "goi_common";
import { baseColors } from "goi_common/src/design-system";

function RenewalFooter({ tone = "default" }: { tone?: "default" | "mypage" }) {
  const { onOpen, onClose } = useDialog();
  const mypage = tone === "mypage";

  return (
    <VStack
      width="100%"
      padding="56px 24px 84px"
      alignItems="center"
      className={mypage ? "caption1" : "caption1 white"}
    >
      <VStack width="100%" gap="24px">
        <VStack gap="24px">
          <GoiLogo color={colors.black} size={40} />
          <VStack
            className={mypage ? "body_14_r" : "body_14_r gray800"}
            gap="6px"
            style={mypage ? { color: baseColors.label_alternative_1 } : undefined}
          >
            {/* /blog 은 Next 페이지가 아니라 rewrite 프록시라서 NextLink(클라이언트 라우팅) 대신 a 태그 사용 */}
            <a
              href="/blog/"
              onClick={() => {
                customEvent({ newGtm: { path: "footer", trigger_and_target: "blog_txt-uv_blog" } });
              }}
            >
              장례 이야기
            </a>
            <div
              onClick={() =>
                onOpen({
                  type: 1,
                  header: "준비 중입니다",
                  children: (
                    <>
                      불편을 드려 죄송합니다.
                      <br />곧 업데이트 될 예정입니다.
                    </>
                  ),
                  footerProps: {
                    text: "확인",
                    onClick: onClose,
                  },
                })
              }
            >
              공지사항
            </div>
            <a
              href="https://goifuneral.notion.site/22e2ed3aa6c54e04822d9669c572c0a1"
              target="_blank"
            >
              이용약관
            </a>
            <a
              className={mypage ? "subtitle_14_sb" : "subtitle_14_sb gray800"}
              href="https://goifuneral.notion.site/544becd151c946618d151bd9b2659414"
              target="_blank"
            >
              개인정보처리방침
            </a>
            <a
              href={GOI_AUDIT_REPORT_URL}
              onClick={() => {
                customEvent({ newGtm: { path: "footer", trigger_and_target: "report" } });
              }}
              target="_blank"
            >
              감사보고서
            </a>

            <a href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=8318701971">사업자정보확인</a>
            {mypage ? null : (
              <>
                <NextLink
                  href="/my/v3"
                  onClick={() => {
                    customEvent({ newGtm: { path: "footer", trigger_and_target: "mypage-uv_my" } });
                  }}
                >
                  마이페이지
                </NextLink>
                <NextLink
                  href="/my/v3"
                  onClick={() => {
                    customEvent({
                      newGtm: { path: "footer", trigger_and_target: "cs_center-uv_my" },
                    });
                  }}
                >
                  고객센터
                </NextLink>
              </>
            )}
            <NextLink
              href="/consultant/search/"
              onClick={() => {
                customEvent({
                  newGtm: { path: "footer", trigger_and_target: "footer-uv_consultant-search" },
                });
              }}
            >
              상담사 조회
            </NextLink>
          </VStack>
        </VStack>

        <div
          className={mypage ? "caption_12_r" : "gray500 caption_12_r"}
          style={mypage ? { color: baseColors.label_assistive_1 } : undefined}
        >
          <div>{"(주) 고이장례연구소"}</div>
          <div>
            <div>대표이사 : 송슬옹 | 개인정보관리책임자 : 김소현</div>
          </div>
          <div> 주소 : {GOI_COMPANY_ADDRESS} | 전화 문의: 1666-9784</div>

          <div> 이메일 : contact@goifuneral.co.kr</div>
          <div>사업자 등록번호 : 831-87-01971</div>
          <div>통신판매업신고번호 : 2021-서울관악-2417</div>
        </div>
      </VStack>
      <Spacing gap={24} />
      <HLine height="1px" color={colors.gray100} />

      <Spacing gap={24} />
      <VStack width="100%" gap={16}>
        <Box
          className={mypage ? "caption_12_r" : "caption_12_r gray600"}
          color={mypage ? baseColors.label_assistive_1 : undefined}
        >
          © {new Date().getFullYear()}. (주)고이장례연구소 ALL RIGHTS RESERVED.
        </Box>

        <HStack alignItems="center" gap="12px">
          <NextLink
            href="https://www.instagram.com/goi.funeral/"
            onClick={() => {
              customEvent({
                newGtm: {
                  path: "footer",
                  trigger_and_target: "instagram_icon-instagram",
                },
              });
            }}
          >
            <Image
              src={getCdnImageSrc("platform/home/instagram.png")}
              width={24}
              height={24}
              alt="instagram"
            />
          </NextLink>
          <NextLink
            href="https://www.youtube.com/c/고이TV알기쉬운장례정보"
            onClick={() => {
              customEvent({
                newGtm: {
                  path: "footer",
                  trigger_and_target: "youtube_icon-youtube",
                },
              });
            }}
          >
            <Image
              src={getCdnImageSrc("platform/home/youtube.png")}
              width={24}
              height={24}
              alt="youtube"
            />
          </NextLink>

          <NextLink
            href="https://blog.naver.com/PostList.naver?blogId=goifuneral"
            onClick={() => {
              customEvent({
                newGtm: {
                  path: "footer",
                  trigger_and_target: "blog_icon-blog",
                },
              });
            }}
          >
            <Image
              src={getCdnImageSrc("platform/home/blog.png")}
              width={24}
              height={24}
              alt="blog"
            />
          </NextLink>
        </HStack>
      </VStack>
    </VStack>
  );
}

export default RenewalFooter;
